/* The analytics navbar buttons */
import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { NavLink } from 'react-router-dom';
import classNames from 'classnames';

import PremiumIcon from 'js/premium/PremiumIcon';
import PremiumUpsellPopover from 'js/premium/PremiumUpsellPopover';

export const HrefOrLink = ({ href, exact, strict, isActive, ...props }) => {
  if (href) {
    return <a {...props} href={href} className="subnav-link" />;
  }
  return (
    <NavLink
      {...{ ...props, exact, strict, isActive }}
      className="subnav-link"
    />
  );
};

export class ActivityLink extends Component {
  static propTypes = {
    className: PropTypes.string,
    onActive: PropTypes.func,
    premiumFeature: PropTypes.bool,
    isPremium: PropTypes.bool,
    isExternal: PropTypes.bool,
  };

  state = {
    premiumUpsellOpen: false,
  };

  render() {
    const { props, state } = this;
    const { premiumFeature, isPremium } = this.props;

    if (props.hide) return null;

    const upgradeUrl = !(premiumFeature && !isPremium)
      ? null
      : window.$r.upgrade_url({
          feature: premiumFeature,
          trigger: props.upgradeTrigger,
        });

    return (
      <div
        className={props.className}
        onMouseEnter={this.handleMouseEnter}
        onMouseLeave={this.handleMouseLeave}
      >
        <HrefOrLink
          to={!props.isExternal ? props.to : undefined}
          // eslint-disable-next-line prettier/prettier
          href={props.isExternal ? props.to : props.href || upgradeUrl}
          exact={props.exact}
          isActive={this.isActive}
        >
          <span style={{ display: 'flex' }}>
            {Boolean(premiumFeature) && (
              <PremiumIcon marginRight={6} size={12} />
            )}

            {Boolean(props.text) && (
              <span
                className="analytics-dashboard-subnav-text"
                text={props.text}
              >
                {props.text}
              </span>
            )}

            {Boolean(props.children) && <span>{props.children}</span>}

            {Boolean(props.redDot) && (
              <span className="NavUnreadBubble NavUnreadBubble--afterText" />
            )}
          </span>
        </HrefOrLink>
        {Boolean(premiumFeature) && !isPremium && (
          <PremiumUpsellPopover
            show={state.premiumUpsellOpen}
            bodyText={props.popoverBodyText}
            buttonUrl={upgradeUrl}
            buttonText={props.popoverButtonText}
          />
        )}
      </div>
    );
  }

  handleMouseEnter = () => {
    clearTimeout(this.hideTimeout);
    this.setState({ premiumUpsellOpen: true });
  };

  handleMouseLeave = () => {
    this.hideTimeout = setTimeout(() => {
      this.setState({ premiumUpsellOpen: false });
    }, 200);
  };
}

// todo: remove and replace kale tracking
export const ActivityListLink = ({ className, ...props }) => (
  <li
    className="u-floatLeft"
    onClick={() => {
      window.Kale.notify({
        collectionName: 'analytics_tabs',
        eventData: {
          to: props.to,
          time_of: Date(),
          visiting_user_id: window.$current_user?.id,
          visited_user_id: window.$viewed_user?.id,
          is_mobile: window.matchMedia('(max-width: 767px)').matches,
        },
      });
    }}
  >
    <ActivityLink
      {...props}
      className={classNames(
        className,
        'analytics-dashboard-subnav-link u-fs12 u-positionRelative',
        ' u-clickable PremiumIconContainerHoverWrapper',
      )}
    />
  </li>
);
